import { Component, OnInit } from '@angular/core';
import { TicketModel } from 'src/app/shared/models/domain/ticket.model';
import { BaseEntryPageComponent } from 'src/app/shared/components/base/base-entry-page.component';
import { RoutingService } from 'src/app/core/services/app/routing.service';
import { NotificationService } from 'src/app/core/services/app/notification.service';
import { PendingChangesService } from 'src/app/core/services/app/pending-changes.service';
import { TicketService } from 'src/app/core/services/domain/ticket.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-ticket-page',
  templateUrl: './ticket-page.component.html',
  styleUrls: ['./ticket-page.component.scss']
})
export class TicketPageComponent extends BaseEntryPageComponent<TicketModel> implements OnInit {
  constructor(private ticketService: TicketService,
              private router: Router,
              routingService: RoutingService,
              notificationService: NotificationService, pendingChangesService: PendingChangesService) {
    super(notificationService, routingService, pendingChangesService);
  }

  ngOnInit(): void {
    this.value = new TicketModel();
  }

  onSaveClicked(): void {
    this.isSaving = true;
      this.ticketService.create(this.value).subscribe(_ => {
        this.onSaveSuccess('Thank you for your reply.  We will respond within 48 hours.');
        this.router.navigateByUrl(this.routeUtilities.routes.application.help.getNavigateUrl());
      }, err => {
        this.onSaveFailed(err);
      });
    }
}

